/**
 * Resolves image URLs to work on any domain.
 * - External URLs (http/https) → returned as-is (CDN, Hostinger, etc.)
 * - Relative paths (/api/images/...) → prepend current backend URL
 * - Empty/null → returns fallback placeholder
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://junk-in-da-truck-production.up.railway.app';

export function resolveImageUrl(url, fallback = '') {
  if (!url) return fallback;
  
  // Already a full URL (Cloudinary CDN, Hostinger, external)
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // Relative API path — prepend backend URL
  if (url.startsWith('/api/')) {
    return `${BACKEND_URL}${url}`;
  }
  
  // Any other relative path
  if (url.startsWith('/')) {
    return `${BACKEND_URL}${url}`;
  }
  
  return url || fallback;
}
